module.exports = __webpack_public_path__ + "fonts/MullerMediumItalic.a3e2fe58.ttf";